var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"iconfont icon-arrow-left back",on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }